module.exports = __webpack_public_path__ + "static/media/loader.ff806f6e.svg";